import React from 'react';
import { Sales } from '../../types';
import { DefaultView, PilotView } from './Views';

interface AnalyticsProps {
  todaySales: Sales;
}

export const Analytics = ({ todaySales }: AnalyticsProps) => {
  const { pilotUser: isPilotUser } = todaySales;

  if (isPilotUser) return <PilotView todaySales={todaySales} />;
  return <DefaultView todaySales={todaySales} />;
};
